<template>
<v-dialog
    v-model="dialog"
    max-width="900"
>
    <v-card>
        <v-card-title>Send setup account / reset password link...</v-card-title>

        <v-card-text
            v-if="reset_request != null"
        >
            <v-text-field
                label="Username"
                :value="reset_request.employee_username"
                disabled
                autocomplete="off"
            />

            <m-edit-text
                :label="link_type == 'reset' ? 'Password reset link' : 'Setup account link'"
                :value=reset_request.password_reset_url
                read_only
            />

            Send Link To:<br/>

            <v-checkbox
                v-for="(item, index) in send_to_options"
                :key="index"
                close
                style="margin-bottom: 15px;"
                :label="item.text"
                :value="item.value"
                v-model="send_to"
            />

            <m-icon-bar
                v-on:add="onAddPhoneNumber"
                style="margin-bottom: 15px;"
            />

            <v-textarea
                label="Introductory Message"
                v-model="intro_message"
            />

              
        </v-card-text>

        <v-card-actions>
            <v-spacer></v-spacer>

            <v-btn
                text
                @click="onCancel"
            >
            Cancel
            </v-btn>

            <v-btn
                color="primary darken-1"
                text
                @click="onSend"
                :disabled="send_to.length == 0"
            >
            Send
            </v-btn>

        </v-card-actions>

    </v-card>
</v-dialog>
</template>

<script>

const E164 = require('@/js/E164.js');

export default {

    data() {
        return {
            dialog: false,
            employee_id: null,
            reset_request: null,
            intro_message: null,
            link_type: 'reset',

            send_to_options: [],
            send_to: [],
        }
    },

    methods: {
        
        showDialog(employee_id)
        {
            this.employee_id = employee_id;

            this.$rc.rest({
                'spinner': true,
                'endpoint': 'PUT: /api/v1/auth/start-password-reset-by-org-admin',
            
                'params' : {
                        'employee_id': this.employee_id,
                    },
            
                'on_success': (data) => {
                        
                        this.reset_request = data;

                        let send_to = [];
                        let send_to_options = [];

                        for ( let i = 0; i < data.personal_devices_to_notify.length; i++ )
                        {
                            let device = data.personal_devices_to_notify[i];

                            send_to_options.push({
                                'text' : device.label + ' - '+ E164.prettyPrintUsPhoneNumber(device.endpoint),
                                'value' : device.endpoint,
                            });

                            send_to.push(device.endpoint);
                        }

                        this.intro_message = "Hi!  This is the RedChirp Bot.  I understand that you need to reset your password.  To do so, use the following link (valid for seven days):";
                        this.link_type = 'reset';

                        if ( data.has_password == false )
                        {
                            this.link_type = 'setup';
                            this.intro_message = "Welcome to RedChirp!  To setup your password use the following link (valid for seven days):";
                        }

                        this.send_to = send_to;
                        this.send_to_options = send_to_options;

                        this.dialog = true;
                    },
            
                'on_error': 'Unable to create setup / password reset links.',
            });
        },

        checkboxLabel(device)
        {
            if ( device.label != null )
            {
                return device.label + ' - '+ E164.prettyPrintUsPhoneNumber(device.endpoint);
            }
            else
            {
                return E164.prettyPrintUsPhoneNumber(device.endpoint);
            }
        },

        onAddPhoneNumber()
        {
            this.$rc.prompt({
                'title' : 'Enter a phone number to send the reset link to',
                'label' : 'Phone Number',

                'is_valid' : (value) => {
                    return E164.createEndpointFromUSPhoneNumber(value,null) != null;
                },

                'after_prompt' : (value) => {

                    let new_endpoint = E164.createEndpointFromUSPhoneNumber(value,null);
                    if ( new_endpoint == null ) return;

                    this.send_to_options.push({
                            'text' : E164.prettyPrintUsPhoneNumber(new_endpoint),
                            'value' : new_endpoint,
                        });
                    
                    this.send_to.push(new_endpoint);
                }
            });
        },

        onSend()
        {
            this.dialog = false;

            this.$rc.rest({
                'spinner': true,
                'endpoint': 'POST: /api/v1/auth/send-password-reset-by-org-admin',
            
                'params': {
                    'request_id': this.reset_request.password_reset_request_id,
                    'intro_message': this.intro_message,
                    'endpoints': this.send_to,
                },

                'on_success': (data) => {
                    this.$rc.snackbar('Password reset link sent',3500);
                },

                'on_error': 'Unable to text password reset links',
            });
        },

        onCancel()
        {
            this.dialog = false;
        },

    },
}
</script>

<style lang="scss" scoped>
</style>